import BackupUser from "../backup/backup.user";

const ImageUser = () => <BackupUser backupKind="image" />;

export default ImageUser;
